// Generated by ts-to-zod
import { z } from 'zod';
import { idSchema } from '../../utils/codecUtils.schema';
import { paginationQuerySchema } from '../../utils/listQuery.schema';

export const workflowsListQuerySchema = z
  .object({
    id: z.union([idSchema, z.array(idSchema)]),
  })
  .partial()
  .and(paginationQuerySchema);
